module.exports = __webpack_public_path__ + "static/media/roboto9.9b3766ef.woff2";